import {
  helpers
} from 'vuelidate/lib/validators'
export default (length) => helpers.withParams({
  type: 'exactLength',
  exact: length
},
(value) => !helpers.req(value) || value.length === length)
